<!-- Pug Template -->
<template lang="pug">
.tech-company-company
	.text-center.py-5(
		v-if="loading"
	)
		h4.font-sans Loading...
		.spinner-border.text-primary(
			role="status"
		)
	div(
		v-if="company.id"
	)

		.tech-company-vertical-heading.card.card--heading.p-4.align-items-start.text-white.mb-4.fade-down.card--heading(
			:style="headerStyle"
			data-in-view
		)
			.mx-n3.mb-3.align-self-stretch
				.scroll-x.pb-2
					.d-flex.px-3
						router-link.btn.btn-icon.flex-shrink-0.btn-pill.btn-white.btn-outline.font-sans.btn-lg.text-center(
							:to="backButton"
						)
							span.mdi.mdi-arrow-left
						.btn.btn-lg.btn-outline.btn-white.btn-pill.breadcrumb.ml-2.mr-3
							router-link.text-white.font-sans(
								:to="{name: 'index'}"
							) All Stages
							span.mdi.mdi-chevron-right.mx-1

							router-link.text-white.font-sans(
								:to="{name: 'stage', params: {stage_slug: stage.slug}}"
							) 0{{ stage.number }}. {{ stage.name }}
							span.mdi.mdi-chevron-right.mx-1

							template(
								v-if="parent"
							)
								router-link.text-white.font-sans(
									:to="{name: 'vertical', params: {vertical_slug: parent.slug}}"
								) {{ parent.name }}
								span.mdi.mdi-chevron-right.mx-1

							router-link.text-white.font-sans(
								:to="{path: `/vertical/${vertical_slug}`}"
							) {{ vertical.name }}
			.row.align-items-center.mx-n4.align-self-stretch
				
				.col-12.col-lg.px-4
					h1.display-4.text-white.mb-0(v-html="company.title.rendered")
				
				.col-12.col-lg-auto.px-4.text-right
					a.text-white.btn.btn-white.btn-outline.btn-pill.btn-lg.font-sans(
						v-if="company.acf.company_website"
						:href="company.acf.company_website"
						target="_blank"
					) {{ website }}
						span.mdi.mdi-open-in-new.ml-1

			.justify-content-between.mb-n3.mt-1.w-100.d-none(
				v-if="next || prev"
			)
				a.btn.btn-secondary(
					v-if="prev"
					:href="prev"
				) 
					span.mdi.mdi-arrow-left
				span
				a.btn.btn-secondary(
					v-if="next"
					:href="next"
				)
					span.mdi.mdi-arrow-right

		.row
			.col-12.col-lg-8.order-1.order-lg-0

				section.mb-3(
					data-in-view
					v-for="section in mainSections"
					:key="section.key"
					v-if="company.acf[section.key]"
				)
					.meta-label(v-html="section.label")
					div(v-html="company.acf[section.key]")
			
			.col-12.col-lg-4.order-0.order-lg-1
				// logo
				img.logo.mb-4(
					data-in-view
					v-if="image"
					:src="image.source_url"
					:alt="image.alt_tag"
				)

				section.mb-3(
					v-if="company.acf.headquarters"
					data-in-view	
				)
					.meta-label Headquarters
					div(v-html="company.acf.headquarters")

				section.mb-3(
					v-if="hasContactInfo"
					data-in-view
				)
					.meta-label Contact
					div(
						v-if="company.acf.contact_name"
					) 
						span.mdi.mdi-account-circle.mr-1
						span {{ company.acf.contact_name }}
					
					div(
						v-if="company.acf.contact_email"
					)
						span.mdi.mdi-email.mr-1
						a(
							:href="`mailto:${company.acf.contact_email}`"
						) {{ company.acf.contact_email }}

					div(
						v-if="company.acf.contact_phone_number"
					)
						span.mdi.mdi-phone.mr-1
						a(
							:href="`tel:${company.acf.contact_phone_number}`"
						) {{ company.acf.contact_phone_number }}




</template>

<!-- Script -->
<script>
import store from './store';
const $ = jQuery;
export default {
	props: {
		slug: {
			type: String,
			required: true
		}
	},

	data(){
		return {
			boxes: $('.tech-company-boxes').first(),
			selected: []
		}
	},

	computed: {
		company(){
			return store.getCompany(this.slug).data;
		},
		vertical(){
			return store.verticalById(this.company['tech-vertical'][0]);
		},
		stage(){
			return store.stageById( this.company['tech-stage'][0] );
		},
		headerStyle(){
			return {
				backgroundColor: this.stage.backgroundColor
			}
		},
		parent(){
			return this.vertical.parent ? store.verticalById(this.vertical.parent) : null;
		},
		vertical_slug(){
			return this.parent ? this.parent.slug +'/'+ this.vertical.slug : this.vertical.slug;
		},
		children(){
			return store.verticals.filter( v => v.parent == this.vertical.id );
		},
		backButton(){
			return {name: 'vertical', params:{ vertical_slug: this.vertical.slug }};
		},
		loading(){
			return store.getCompany(this.slug).loading;
		},
		image(){
			try {
				return this.company._embedded['wp:featuredmedia'][0];
			}catch(e){
				return false;
			}
		},
		mainSections(){
			if( !this.company.acf ){
				return;
			}
			return [{
				key: 'product_description',
				label: `About ${this.company.title.rendered}`
			},{
				key: 'unique_differentiator',
				label: "Why We're Different"
			},{
				key: 'pricing_model',
				label: 'Revenue Model'
			},{
				key: 'size_of_business_served',
				label: 'Size of Business Served'
			},{
				key: 'staffing_verticals_served',
				label: 'Staffing Verticals Served'
			},{
				key: 'perm_temp_or_contract',
				label: 'Perm, Temp or Contract'
			},{
				key: 'client_highlights',
				label: 'Client Highlights'
			}]
		},
		hasContactInfo(){
			return this.company.acf.contact_name || this.company.acf.contact_email || this.company.acf.contact_phone_number;
		},
		website(){
			return this.company.acf.company_website.replace(/(^https?:\/\/|\/$)/gi, '');
		},

		index(){
			return this.orderedIds.indexOf(this.company.id);
		},

		next(){
			if( this.orderedIds[this.index+1] ){
				return this.boxes.find('[data-id="'+this.orderedIds[this.index+1]+'"]').data('permalink');
			}
			return false;
		},

		prev(){
			if( this.orderedIds[this.index-1] ){
				return this.boxes.find('[data-id="'+this.orderedIds[this.index-1]+'"]').data('permalink');
			}
			return false;
		},

		orderedIds(){
			const selectors = this.vertical.posts.map( id => '[data-id="'+id+'"]')
			const ids = this.boxes.find(selectors.join(',')).map( (index, el) => {
				return $(el).data('id')
			}).get();
			return ids;
		}
	},

	created(){
		
	},

	watch: {
		loading(v){
			setTimeout( () => this.$emit('refreshInView'), 100 );
		}
	},

	mounted(){
		
	},

	updated(){
		
	},

	methods: {
		
	}
};
</script>

<!-- SCSS Style -->
<style lang="scss" scoped>
.breadcrumb {

	white-space: nowrap;

	&:hover {
		background: transparent;
		color: inherit !important;
	}

	> * {
		white-space: nowrap;
	}

	a {
		font-weight: 600;
		&:hover {
			text-decoration: underline;
		}
	}
}

.border-left {
	@media (max-width: 991px){
		border-left-width: 0;
	}
}

.scroll-x {
	overflow-x: auto;
	scroll-behavior: smooth;
	&::-webkit-scrollbar { width: 0 !important }
}

.logo {
	aspect-ratio: 5 / 3;
	object-fit:contain;
	object-position: 50% 50%;
	padding: 10px;
}
</style>